import { Component, OnInit, ViewChild, Input } from '@angular/core';

import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AccountService } from "../../../services/account.service";
import { Utilities } from '../../../services/utilities';
import { User } from '../../../models/user.model';
import { UserEdit } from '../../../models/user-edit.model';
import { Role } from '../../../models/role.model';
import { Permission } from '../../../models/permission.model';
import { RouterLink, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-account-create',
  templateUrl: './account-create.component.html',
  styleUrls: ['./account-create.component.css'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
  ]
})
export class AccountCreateComponent implements OnInit {

  private showValidationErrors = false;
  private user: User = new User();
  private isChangePassword = false;

  public formResetToggle = true;
  public userEdit: UserEdit = new UserEdit();

  @ViewChild('f')
  private form;

  constructor(private alertService: AlertService, private accountService: AccountService) {
  }

  ngOnInit() {
  }


  public save() {
    this.alertService.startLoadingMessage("Saving changes...");

    this.accountService.newUser(this.userEdit)
      .subscribe({
        next: user => {

        this.saveSuccessHelper(user);
        this.alertService.stopLoadingMessage();
      }, 
      error: (error) => this.saveFailedHelper(error)});
  };




  private saveSuccessHelper(user?: User) {
    this.showValidationErrors = false;
    this.resetForm();

    this.alertService.showMessage("Success", `User \"${user.email}\" was created successfully`, MessageSeverity.success);
  }


  private saveFailedHelper(error: any) {
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "The below errors occured whilst saving your changes:", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  resetForm(replace = false) {
    this.isChangePassword = false;

    if (!replace) {
      this.form.reset();
    }
    else {
      this.formResetToggle = false;

      setTimeout(() => {
        this.formResetToggle = true;
      });
    }
  }

}

